// This file is generated by a script and should not be modified directly.
const markdown: string = "Search radius in km, useful if a latitude and longitude are provided. The value must be between 0 and 200 and will default to 30.\n"
export default markdown
